import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
  isOverflown,
  numOfWords,
  breakInMultipleLines,
} from '@/checkout-instore-legacy/utils/ellipsisUtils'

class MultilineEllipsisText extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      lines: null,
    }
  }

  handleNameRef = (nameElm) => {
    if (!nameElm || !this.props.name) {
      return
    }
    if (!isOverflown(nameElm) || numOfWords(this.props.name === 1)) {
      return
    }
    const lines = breakInMultipleLines(
      this.props.name,
      this.props.maxCharactersPerLine,
      this.props.maxNumOfLines
    )
    this.setState({
      lines,
    })
  }

  render() {
    const { lines } = this.state
    const {
      classNameContainer,
      classNameLine,
      extraClassNameLastLine,
    } = this.props
    return (
      <div className={`flex flex-column ${classNameContainer}`}>
        {lines ? (
          lines.map((line, index) =>
            line ? (
              <span
                key={index}
                className={classNames(
                  classNameLine,
                  {
                    [extraClassNameLastLine]: index + 1 === lines.length, // lastLine
                  },
                  'w-100 truncate'
                )}
              >
                {line}
              </span>
            ) : null
          )
        ) : (
          <span
            className={`${classNameLine} w-100 truncate`}
            ref={(nameElm) => this.handleNameRef(nameElm)}
          >
            {this.props.name}
          </span>
        )}
      </div>
    )
  }
}

MultilineEllipsisText.propTypes = {
  name: PropTypes.string.isRequired,
  maxNumOfLines: PropTypes.number,
  maxCharactersPerLine: PropTypes.number,
  classNameContainer: PropTypes.string,
  classNameLine: PropTypes.string,
  extraClassNameLastLine: PropTypes.string,
}
MultilineEllipsisText.defaultProps = {
  maxNumOfLines: 2,
  classNameContainer: 'flex-auto pv3',
  classNameLine: 'border-box f3 fw3',
  extraClassNameLastLine: 'pr5',
}

export default MultilineEllipsisText
